<template>
  <section>
    <div>
      <p><b>Atenção:</b> Pode levar entre 10~20 Minutos para puxar os dados inicias de marketing.</p>
    </div>
    <div class="box margin-top-l">
      <div class="box-title">
        <div class="flex middle">
          <div class="flex-1">
          <h3>Perfil(s) Facebook</h3>
          <div class="margin-top-s">
              Status:
              <span v-if="hasOneIntegrationActive">
                <b style="color: green;">ATIVA</b>
              </span>
              <span v-else>
                <b style="color: red;">DESATIVADA</b>
                <p>
                  <small>Entre com sua conta do facebook ads para ativar.</small>
                </p>
              </span>
            </div>
        </div>
        <div class="flex-1 flex end">
          <div>
              <div>
                <div class="facebook connect" @click="createLoginFacebookOauth2()">
                  Entrar com o Facebook
                </div>
              </div>
          </div>
        </div>
      </div>
      </div>
      <div class="box-content">
        <div class="list-account">
          <!-- list accounts -->
          <p>
            Lista dos perfils que você liberou acesso:
          </p>
          <ul class="margin-top-l">
            <li v-for="(pro, index) in profiles" :key="index">
              <div class="flex middle">
                <div class="flex-3">
                  {{ pro.name }} - {{ pro.email }}
                </div>
                <div class="flex-1">
                  <div class="flex end">
                    <div v-if="pro.status === 'ACTIVE'" class="button secondary" @click="deleteIntegration(pro)">Remover Perfil</div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div v-if="loadingProfiles">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
        </div>
      </div>
    </div>
    <!-- accounts -->
    <div class="box margin-top-l" style="margin-left: 0px;">
      <div class="box-title">
        <div class="flex middle">
          <div class="flex-1">
            <h3>Contas de Anúncio: {{ countActiveAccounts }}/{{ accountsLimit }}</h3>
            <p>Precisa de mais conta de anúncio ativas? <router-link :to="{ name: 'SubscriptionRedirect' }">Faça Upgrade</router-link></p>
          </div>
        </div>
      </div>
      <div v-if="checkResource('config-accounts-fbads')" class="box-content">
        <div class="list-account">
          <!-- list accounts -->
          <p>
            Lista de contas de anúncio com acesso. Ative a conta que deseja ter
            os dados no dashboard:
          </p>
          <ul class="margin-top-l">
            <li v-for="(acc, index) in accounts" :key="index">
              <div class="flex">
                <div class="flex-3">{{ acc.name }}</div>
                <div class="flex-1">
                  <div class="flex end">
                    <m-switch
                      v-if="(acc.is_active && !hasSlotToAccout) || (hasSlotToAccout)"
                      v-model="acc.is_active"
                      @change="saveChanges(acc)"
                    ></m-switch>
                    <div v-else class="flex center end" >* Faça upgrade para tivar mais contas</div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div v-if="loading">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
        </div>
      </div>
      <div v-else class="box-content">
        <p> Seu plano não tem a funcionalidade de FACEBOOK ADS. <router-link :to="{ name: 'SubscriptionRedirect' }"><b>Faça o UPGRADE para poder utilizar esse recurso</b></router-link></p>
      </div>
    </div>

  </section>
</template>

<script>
import { mapState } from "vuex";

import {
  getIntegrations,
  initFacebookOauth2,
  saveIntegration,
  getAccountsFacebookAds,
  deleteIntegration,
} from "@/services/integration";

import MSwitch from "@/components/MSwitch.vue";

export default {
  components: { MSwitch },
  name: "facebook-ads",
  data() {
    return {
      status: "DISABLED",
      accounts: [],
      profiles: [],
      accountsIntegration: [],
      listAccountsFacebookAds: [],
      newAccountFacebookAds: "",
      detectTokenDataOauth: null,
      showModalDelete: false,
      showModalDeleteIntegration: false,
      modalNewAccount: false,
      loading: false,
      loadingProfiles: false,
      timerToRequest: 3000,
    };
  },
  computed: {
    ...mapState({ account: (state) => state.account }),
    hasIntegration() {
      return this.profiles && this.profiles.length > 0;
    },
    hasOneIntegrationActive() {
      let status = false

      this.profiles.forEach(p => {
        status = p.status == 'ACTIVE'
        if (status) return
      })

      return status
    },
    accountsLimit() {
      if (!this.account) {
        return
      }

      return this.account.plan_limits.limit_accounts_fbads
    },
    countActiveAccounts() {
      if (!this.accounts) {
        return true
      }

      let count = 0
      this.accounts.forEach(a => {
        if (a.is_active) {
          count += 1
        }
      })

      return count
    },
    hasSlotToAccout() {
      if (this.account.plan_limits.limit_accounts_fbads === 0) {
        return true
      }

      return this.countActiveAccounts < this.account.plan_limits.limit_accounts_fbads
    }
  },
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.detectTokenDataOauth);
  },
  methods: {
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
    deleteIntegration(integration) {
      deleteIntegration(integration.id)
        .then(() => {
          this.accounts = this.accounts.filter((acc) => { return acc.integration_id != integration.id });
          this.profiles = this.profiles.filter((pro) => { return pro.id != integration.id })

          this.$toast.success({
            title: "Sucesso",
            message: "Integração removida com sucesso",
          });
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um erro ao tentar deletar integração",
          });
        });
    },
    saveChanges(acc) {
      let params = {
        facebook: {
          integration_id: acc.integration_id,
          accounts: this.accounts.filter((a) =>  {
            return a.is_active && a.integration_id === acc.integration_id
          }),
        },
      };
      saveIntegration(params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: `Integração com Facebook salva com sucesso.`,
          });
          //this.getData();
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um erro ao tentar salvar integração",
          });
        });
    },
    getData(notLoading) {
      if (!notLoading) {
        this.loadingProfiles = true;
      }

      getIntegrations()
        .then((result) => {
          this.accountsIntegration = [];
          result.facebookads.forEach((element) => {
            element.accounts.forEach((acc) => {
              acc.is_active = true;
              acc.integration_id = element.id;

              this.accountsIntegration.push(acc)
            })
          });

          // detect change profile list
          if (this.profiles.length !== result.facebookads.length) {
              clearInterval(this.detectTokenDataOauth);
              if (this.checkResource('config-accounts-fbads')) {
                this.getAccountsFacebook();
              }
          }

          this.profiles = result.facebookads
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          console.log('error', error)
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um erro ao tentar buscar integrações",
          });
        })
        .finally(() => {
          this.loadingProfiles = false;
        });
    },
    getAccountsFacebook() {
      this.loading = true;

      getAccountsFacebookAds()
        .then((responseFb) => {
          let accountsIds = this.accountsIntegration.map((acc) => acc.id);

          responseFb.accounts.forEach((element) => {
            let is_active = false;
            if (accountsIds.includes(element.id)) {
              is_active = true;
            }
            this.accounts.push(
              Object.assign(element, { is_active: is_active })
            );
          });

          this.accounts = this.accounts.sort(function(a, b) {
            return !a.is_active && b.is_active;
          });

          this.accounts = this.$ObjectCopy(this.accounts);
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createLoginFacebookOauth2() {
      initFacebookOauth2()
        .then((result) => {
          // set interval to refresh screen to get data
          this.detectTokenDataOauth = setInterval(() => {
            this.getData(true);
          }, this.timerToRequest);

          this.win = window.open(
            result.url,
            "Oauth2",
            "resizable,height=800,width=600"
          );
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao iniciar oauth",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.list-account {
  ul {
    list-style-type: none;
    li {
      margin-bottom: 8px;
      padding: 16px;
      border-radius: 5px;
      border: 1px solid var(--border);
    }
  }
}



.facebook {
    cursor: pointer;
    font-family: Lucida Grande, Helvetica Neue, Helvetica, Arial, sans-serif;
    display: inline-block;
    font-size: 14px;
    font-weight: 800;
    padding: 13px 30px 15px 44px;
    background: #1877f2;
    color: #fff;
    text-shadow: 0 -1px 0 rgba(0,0,20,.4);
    text-decoration: none;
    line-height: 1;
    position: relative;
    border-radius: 5px;
}

.connect:before {
    display: inline-block;
    position: relative;
    background-image: url(data:image/png;base64,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);
    height: 23px;
    background-repeat: no-repeat;
    background-position: 0px 3px;
    text-indent: -9999px;
    text-align: center;
    width: 29px;
    line-height: 23px;
    margin: -8px 7px -7px -30px;
    padding: 2 25px 0 0;
    content: "f";
}
</style>
